import MuiListItemButton from "@mui/material/ListItemButton";

export default function ListItemButton(props) {
  return <MuiListItemButton {...props} />;
}
